export const manageWorkforceSchema = {
  
    location: {
        type: "string",
        required: true,
        properties: {
            empty: "Please select geography",
        }
    },
   
    numberOfStaffOnCovidRelatedAbsence: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter no. of staff on covid related absence",
            positive: "Number of staff on covid related absence must be at least 0",
            number: "Please enter number only",
            maxLength:{
                limit:3,
                msg: "Number of staff on covid related absence of beds is not allow more than 100" 
            }, 
        }
    },

    numberOfEnrichedStaff: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter no. of enriched staff",
            positive: "Number of enriched staff must be at least 0",
            number: "Please enter number only",
            maxLength:{
                limit:3,
                msg: "Number of enriched staff is not allow more than 100" 
            }, 
           
        }
    },

    issueAffecting: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter issue affecting"
        }
    },

    workforceCapacity: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter workforce capacity"
        }
    },

   
}